/* eslint-disable react/jsx-no-useless-fragment */
/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect } from "react";
import { Link, useParams } from "react-router-dom";
import { useForm } from "react-hook-form";
import { Button, Card, CardBody, Heading, Flex } from "@chakra-ui/react";
import Loader from "../../components/PageLoader";
import BreadCrumb from "../../components/breadCrumb";
import { Paths } from "../../routes/paths";
import { useGetStock } from "../../services/stock";
import FormInput from "../../components/forms/form-Input";
import NumericInput from "../../components/forms/react-hook-numeric-input";
import { DEFAULT_STOCK } from "./constants";

export default function StockDetails() {
  const params = useParams();

  const {
    mutate: getDetails,
    data: detailsRes,
    isPending: gettingDetails,
    // error: detailsError,
    reset: detailsReset,
  } = useGetStock();
  const {
    watch,
    control,
    reset,
    formState: { errors },
  } = useForm({
    defaultValues: { ...DEFAULT_STOCK },
  });
  useEffect(() => {
    if (params.stockId) {
      getDetails(params.stockId);
    }
  }, []);
  useEffect(() => {
    if (detailsRes) {
      const _res = detailsRes.data;

      reset({ ..._res });
      detailsReset();
    }
  }, [detailsRes]);

  const generalFieldProps = { errors, control };

  return (
    <>
      {gettingDetails ? <Loader /> : <></>}

      <div className="form-container">
        <BreadCrumb
          links={[
            { text: "Stocks", link: Paths.stock },
            { text: "Stock Details", isCurrentPage: true },
          ]}
        />
        <Flex w="100%">
          <Card flexDirection="column" w="100%">
            <CardBody>
              <div
                style={{
                  width: "100%",
                  display: "flex",
                  justifyContent: "space-between",
                  gap: "16px",
                }}
              >
                <Heading>Stock Details ({watch("description")})</Heading>
                <Button
                  as={Link}
                  to={`${Paths.editStock}/${params.stockId || watch("id") || watch("stockId")}`}
                >
                  Edit Stock
                </Button>
              </div>

              <form className="add-location-form">
                <FormInput
                  {...generalFieldProps}
                  isRequired
                  label="Cash Center"
                  name="cashCenter"
                  readOnly
                />
                <FormInput
                  {...generalFieldProps}
                  isRequired
                  label="Customer"
                  name="customer"
                  readOnly
                />
                <FormInput
                  {...generalFieldProps}
                  isRequired
                  label="Description"
                  name="description"
                  readOnly
                />
                <FormInput
                  {...generalFieldProps}
                  isRequired
                  label="Denomination"
                  name="denomination"
                  readOnly
                />

                <FormInput
                  {...generalFieldProps}
                  isRequired
                  label="Cassette Type"
                  name="cassetteType"
                  readOnly
                />
                <FormInput
                  {...generalFieldProps}
                  isRequired
                  label="Maker"
                  name="maker"
                  readOnly
                />
                <NumericInput
                  {...generalFieldProps}
                  label="Limit"
                  name="limit"
                />
              </form>
            </CardBody>
          </Card>
        </Flex>
      </div>
    </>
  );
}
